import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';
import ImageLink from '../../js/utils/ImageLink';

export default function HeroSection({ image1, image2 }) {
  const { t } = useTranslation(['AcademicsPage']);

  return (
    <section className="academics-hero-section container">
      <div className="academics-hero-section__content">
        <MainTitle type="dark" className="text--2xl hidden--lg">
          <span>{t('leadershipFocused')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('WorldClassEducation')}
          </span>
        </MainTitle>
        {image1?.url && (
          <div className="academics-hero-section__secondary-media hidden--md">
            <picture>
              <source srcSet={ImageLink(image1?.url)} type="image/webp" />
              <img src={ImageLink(image1?.url)} alt={image1.alt} />
            </picture>
          </div>
        )}

        <div className="academics-hero-section__content-container">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{t('leadershipFocused')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('WorldClassEducation')}
            </span>
          </MainTitle>

          <p>{t('heroSectionDescription')}</p>
        </div>

        <div className="academics-hero-section__media">
          {image1?.url && (
            <div className="academics-hero-section__secondary-media hidden--lg">
              <picture>
                <source srcSet={ImageLink(image1?.url)} type="image/webp" />
                <img src={ImageLink(image1?.url)} alt={image1.alt} />
              </picture>
            </div>
          )}
          {/* {image2?.url && (
            <div className="academics-hero-section__secondary-media">
              <picture>
                <source srcSet={ImageLink(image2?.url)} type="image/webp" />
                <img src={ImageLink(image2?.url)} alt={image2?.alt} />
              </picture>
            </div>
          )} */}
        </div>
      </div>

      <Icon name="spiral-arrow-down" className="spiral-arrow-icon" />
    </section>
  );
}
